const customerHooks = require('./hooks/customer-hooks');

module.exports = {
    before: {
        create: [
            customerHooks.setRandomColorIfNotSet(),
        ]
    }
}